import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'
import commonJs from '@/utils/common'
export default {
	/**
	 * concentrator 列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	concentratorList( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/jk/getConcentrator',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * concentrator 添加
	**/
	concentratorAdd(data){
		return request({
			url: baseUrl + '/jk/addConcentrator',
			method:'POST',
			data
		})
	},

	/**
	 * concentrator 编辑
	**/
	concentratorEdit(id,data){
		return request({
			url: baseUrl + '/jk/editConcentrator/'+id,
			method:'PUT',
			data
		})
	},
	/**
	 * concentrator 删除
	**/
	concentratorDel(id){
		return request({
			url: baseUrl + '/jk/deleteConcentrator/'+id,
			method:'DELETE'
		})
	},

	/**
	 * 回路控制
	 * @param {id} 网关ID
	**/
	loopControl(id,data){
		return request({
			url: baseUrl + '/concentrator/lampLoopControl/'+id,
			method:'POST',
			data
		})
	},

	/**
	 * 对集控进行手动控制开关
	 * @param {type} 1 集控操作  2 表示回路操作
	 * @param {cids} 集控操作:集控的id集合，多个用逗号隔开   回路操作: 只能有一个id 不可以有多个
	 * @param {switch} 1是开 0 是关
	 * @param {loop_ids} 回路的id集合,多个用逗号隔开
	**/
	manualSwitchCenter(data){
		return request({
			url: baseUrl + '/jkswitch/manualSwitchCenter',
			method:'POST',
			data
		})
	},

	/**
	 * 根据集控的id获取回路列表
	 * @param {id} 集控的id
	**/
	getConcentratorLoop(params={}) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/jk/getConcentratorLoop',
	    method: 'GET',
		params
	  })
	},

	/**
	 * 根据集控的id获取回路列表2
	 * @param {id} 集控的id
	**/
	getLoopList(id) {
		return request({
	    url: baseUrl + '/jk/getLoopList/'+id,
	    method: 'GET'
	  })
	},

	/**
	 * 获取集中控制器的每个回路的三相电等数据
	 * @param {id} 集控的id
	**/
	loopPower(id){
		return request({
			url: baseUrl + '/concentrator/getSensor/'+id,
			method: 'GET'
		})
	},

	/**
	 * 根据设备类型获取设备列表
	 * @param {bind_type} 设备类型
	**/
	getDeviceListByDeviceType( params={} ) {
		params = commonJs.obj.removeNullKey(params)
		return request({
	    url: baseUrl + '/jk/getDeviceListByDeviceType',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 恢复策略
	 * @param {id} 集控的id
	 * @param {stg_id} 关联字段,集控策略的id,默认0无关联
	 * @param {ms} 	模式1.手动2.自动, 不传递默认恢复成自动
	**/
	recoveryStrategy(data){
		return request({
			url: baseUrl + '/jkst/recoveryStrategy',
			method:'POST',
			data
		})
	},
}